import React, { Component } from 'react';
import { SocialIcon } from 'react-social-icons';


class Animation extends Component {


    render() {

        return (

            <div class="ticker-wrap">
            <div class="ticker">
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
              <div class="ticker__item">🏝️ Bored Sharks Club</div>
            </div>
            </div>)
    }
}

export default Animation;